import { withLoading } from "hocs/withLoading";
import { lazy } from "react";

export { default as AiAgentButton } from "./AiAgentButton";
export { default as BaseButton } from "./BaseButton";
export { default as BizChatButton } from "./BizChatButton";
export { default as ChatNowButton } from "./ChatNowButton";
export { default as ConfirmButtons } from "./ConfirmButtons";
export { default as DisclaimerButton } from "./DisclaimerButton";
export { default as GetContactButton } from "./GetContactButton";
export { default as GetQuotesButton } from "./GetQuotesButton";
export { default as GoogleButton } from "./GoogleButton";
export { default as GreenButton } from "./GreenButton";
export { default as LockButton } from "./LockButton";
export { default as RegisterButton } from "./RegisterButton";
export { default as SendInquiryButton } from "./SendInquiryButton";
export { default as SendMessageButton } from "./SendMessageButton";
export { default as SwitchModeButton } from "./SwitchModeButton";
export { default as TextButton } from "./TextButton";
export { default as VisitCompanyButton } from "./VisitCompanyButton";
export { default as ViewProductButton } from "./ViewProductButton";
export { default as ShowMoreButton } from "./ShowMoreButton";
export { default as UnlockChatButton } from "./UnlockChatButton";

export const ComplaintButton = withLoading(
  lazy(() => import("./ComplaintButton"))
);
export const ReviewButton = withLoading(
  lazy(() => import("./ReviewButton"))
);
